<section class="messages-container">
  <!-- check chat alert -->
  @switch (alertState) {
    @case (AlertStatesEnum.publicChat) {
      <div class="messages-container__alert">
        <pwj-public-chat-form></pwj-public-chat-form>
      </div>
    }
    @case (AlertStatesEnum.startChatAlert) {
      <div class="messages-container__alert">
        <!-- start support chat alert -->
        <ngx-spinner
          bdColor="transparent"
          size="medium"
          color="var(--primary-dark)"
          type="ball-clip-rotate"
          [fullScreen]="false"></ngx-spinner>
        <pwj-alert-box
          alertMode="oneRoute"
          alertMessage="chat.startConversationWithSupport"
          [alertData]="startChatAlertData"></pwj-alert-box>
      </div>
    }
    @case (AlertStatesEnum.supportChat) {
      <div>
        <!-- chat options section -->
        <pwj-chat-options
          [isSupportChatMod]="isSupportChatMode"
          [businessChatData]="businessChatData"></pwj-chat-options>

        @if (isMessagesLoading) {
          <!-- messages skeleton loader -->
          <pwj-messages-skeleton></pwj-messages-skeleton>
        } @else {
          @if (messages.length > 0) {
            <!-- messages section -->
            <ul
              class="messages-container__list no-scrollbar"
              #messagesContainer>
              <!-- pagination -->

              @if (
                showPagination &&
                !isMessagesLoading &&
                messages.length < messagesCount
              ) {
                <li>
                  <pwj-pagination-on-scroll
                    [dataCount]="messagesCount"
                    [perPage]="20"
                    (setCurrentPage)="
                      fetchDataForNextPage()
                    "></pwj-pagination-on-scroll>
                </li>
              }
              <!-- messages list -->
              @for (message of messages; track i; let i = $index) {
                <li class="message-item" #message>
                  <pwj-message-box
                    [messageIndex]="i"
                    [messageData]="message"></pwj-message-box>
                </li>
              }
            </ul>
          } @else {
            <!-- suggestion messages list -->
            <ul class="messages-container__suggestions-list no-scrollbar">
              @for (message of suggestionMessages; track message) {
                <li class="message-item">
                  <pwj-suggest-message-box
                    [suggestedMessage]="message"></pwj-suggest-message-box>
                </li>
              }
            </ul>
          }
        }

        <!-- message input -->
        <pwj-chat-input></pwj-chat-input>
      </div>
    }
    @case (AlertStatesEnum.businessChat) {
      <div>
        <!-- chat options section -->
        <pwj-chat-options
          [isSupportChatMod]="isSupportChatMode"
          [businessChatData]="businessChatData"></pwj-chat-options>

        @if (isMessagesLoading) {
          <!-- messages skeleton loader -->
          <pwj-messages-skeleton></pwj-messages-skeleton>
        } @else {
          @if (messages.length > 0) {
            <!-- messages section -->
            <ul
              class="messages-container__list no-scrollbar"
              #messagesContainer>
              <!-- pagination -->
              <li>
                <pwj-pagination-on-scroll
                  [dataCount]="messagesCount"
                  [perPage]="20"
                  (setCurrentPage)="fetchDataForNextPage()"
                  [resetCurrentPage]="false"></pwj-pagination-on-scroll>
              </li>
              <!-- messages list -->
              @for (message of messages; track message._id; let i = $index) {
                <li class="message-item" #message>
                  <pwj-message-box
                    [messageIndex]="i"
                    [messageData]="message"></pwj-message-box>
                </li>
              }
            </ul>
          } @else {
            <!-- suggestion messages list -->
            <ul class="messages-container__suggestions-list no-scrollbar">
              @for (message of suggestionMessages; track message) {
                <li class="message-item">
                  <pwj-suggest-message-box
                    [suggestedMessage]="message"></pwj-suggest-message-box>
                </li>
              }
            </ul>
          }
        }

        <!-- message input -->
        <pwj-chat-input></pwj-chat-input>
      </div>
    }
    @default {
      <div>something went wrong</div>
    }
  }
</section>
